import { Button } from '@civilgrid/ui/components';
import { useState } from 'react';
import { clearEsriCache as apiClearEsriCache } from '~/api/internal';
import { Notify } from '~/components2/Notify';
import { MajorHeading } from '../common/Heading';

export default function ClearEsriCache() {
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setIsLoading(true);

      const res = await apiClearEsriCache();

      if (!res.success) {
        throw 'Failed';
      }

      Notify.info({
        title: 'Clear Esri Cache',
        message: 'Redis cache successfully cleared.',
      });
    } catch {
      Notify.error({
        title: 'Clear Esri Cache',
        message: 'An error occurred while attempting to clear Redis cache. Check logs for details',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <MajorHeading tooltip="This clears the Redis cache of all manual ESRI calls (i.e. calls made for the Utilities, Intelligence, etc. tabs). This does NOT clear the tiles or layers cache.">
        Clear Redis Cache
      </MajorHeading>
      <Button onClick={onSubmit} loading={isLoading} disabled={isLoading}>
        Clear
      </Button>
    </div>
  );
}
